import { render, staticRenderFns } from "./feature-settings.vue?vue&type=template&id=7a3e73cc&"
import script from "./feature-settings.vue?vue&type=script&lang=js&"
export * from "./feature-settings.vue?vue&type=script&lang=js&"
import style0 from "./feature-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a3e73cc')) {
      api.createRecord('7a3e73cc', component.options)
    } else {
      api.reload('7a3e73cc', component.options)
    }
    module.hot.accept("./feature-settings.vue?vue&type=template&id=7a3e73cc&", function () {
      api.rerender('7a3e73cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/feature-settings.vue"
export default component.exports